module.exports = __webpack_public_path__ + "img/bona.1f528cd9.png";